module.exports = __webpack_public_path__ + "components/flag/static/square/ai-1ff7f99db3c38cd0d0b71a8d3f74ea75.svg";